import CustomCard from '../../../../../components/card/CustomCard';
import CustomButton, {OutlinedButton, SecondaryButton} from '../../../../../components/CustomButton'
import React, {useEffect, useState} from 'react'
import CustomIcon from '../../../../../components/CustomIcon'
import {useDispatch} from 'react-redux'
import DropDown from '../../../../../components/Dropdown'
import {
  editSpecialization,
  deleteSpeciality,
  getSpecialities
} from '../../../../../redux/slices/doctorSlice'
import TableItemLoader from 'components/TableItemLoader'
import getFilteredList from '../../../../../helpers/filterDropdown';
import Chip from "../../../../../components/form/Chip";
import EmptyState from "../../../../../components/EmptyState";

const Specialization = (props) => {
  const [dropDown, setDropDown] = useState(false)
  const [specialities, setSpecialities] = useState([])
  const [doctorSpecialities, setDoctorSpecialities] = useState([])
  const Dispatch = useDispatch()

  const removeSpecialities = (id) => {
    let payload = {
      id: props.profile.id,
      specialityId: id,
    }
    Dispatch(deleteSpeciality(payload))
  }

  const addSpeciality = (item) => {
    let payload = {
      doctorId: props.profile.id,
      speciality: {
        speciality_id: item.id,
      },
    }
    Dispatch(editSpecialization(payload))
  }

  const fetchSpecialities = () => {
    Dispatch(getSpecialities())
  }

  useEffect(() => {
    setDoctorSpecialities(getFilteredList(props?.profile?.specialization, props.specialities))
    setSpecialities(props?.profile?.specialization)
  }, [props])

  const SpecialitesButton = (specialization) => {
    return (
      <Chip label={specialization.data.label} onClick={() => removeSpecialities(specialization.data.id)}/>
    )
  }

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-2 h-9">
        <div className="font-medium">Specialities</div>
        {
          !dropDown && (
            <OutlinedButton isIconButton={true}
                          onClick={() => setDropDown(true)}
            >
              <CustomIcon icon="add"/>
            </OutlinedButton>
          )
        }
      </div>
      <div className="custom-card">
        <div className="flex flex-wrap">
          {specialities.map((data, index) => (
            <SpecialitesButton data={data} key={data.id} className=""/>
          ))}
        </div>
        {specialities.length === 0 && (
          <EmptyState message="No specialities added." isSmall={true} icon="workspace_premium"/>
        )}
        {dropDown ? (
          <>
            {props.isLoading || props.error.length > 0 || props.specialities.length === 0 ? (
              <TableItemLoader
                loading={props.isLoading}
                error={props.error}
                isEmpty={props.specialities === 0}
                retry={fetchSpecialities}
                count={1}
              />
            ) : (
            <div className="my-4">
              <DropDown
                options={doctorSpecialities}
                onChange={addSpeciality}
                placeholder="Select Specilaities..."
              />
            </div>
            )}
            <div className="flex justify-end">
              <SecondaryButton
                onClick={() => setDropDown(false)}
              >
                {' '}
                Cancel
              </SecondaryButton>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default Specialization
